import React, { useRef } from "react";
import { Pie } from "@ant-design/charts";

const basic = {
	angleField: "value",
	colorField: "key",
	radius: 0.8,
	autoFit: true,
	appendPadding: 10,
};

const innerLabel = {
	type: "inner",
	offset: "-0.5",
	content: "{percentage}",
	style: {
		fill: "#fff",
		fontSize: 14,
		textAlign: "center",
	},
};

const outerLabel = {
	type: "outer",
};

const interactions = [{ type: "element-active" }];
const legend = {
	position: "top",
};
const statistic = {
	title: {
		offsetY: -20,
		style: {
			fontSize: 20,
		},
		formatter: (datum) => (datum ? datum.type : "Total"),
	},
	content: {
		offsetY: 10,
		style: {
			fontSize: 20,
		},
		formatter: (datum, data) =>
			datum
				? `${datum.value}`
				: `${data.reduce((r, d) => r + d.value, 0)}`,
	},
};
const innerRadius = 0.6;

export default function PieChart(chartData = [], chartConfig = {}) {
	const label = chartConfig.label ? innerLabel : outerLabel;
	const config = {
		data: chartData,
		...basic,
		label: label,
		legend: chartConfig.legend ? legend : false,
		innerRadius: chartConfig.isDonut ? innerRadius : 0,
		statistic:
			chartConfig.statistic && chartConfig.isDonut ? statistic : false,
		interactions,
	};
	const ref = useRef();

	return <Pie {...config} chartRef={ref} />;
}
